import { useCallback, useEffect, useState } from "react";
import { OPEN_NOW_CATEGORY, OPEN_NOW_FILTER_OBJ } from "../../utils";
export const useStoreFilters = ({ selectedFilters, allFilters, handleChangeFilters, isOpenNowFilterEnabled, }) => {
    const [activeFilters, setActiveFilters] = useState({});
    const applyFilters = ({ categoryToSkip, additionalCategory = {} } = {}) => {
        let currentFilters = {};
        const filtersCategories = { ...activeFilters, ...additionalCategory };
        Object.keys({ ...activeFilters, ...additionalCategory }).forEach((category) => {
            if (category === categoryToSkip)
                return;
            filtersCategories[category].forEach((filter) => {
                currentFilters = {
                    ...currentFilters,
                    [`${category}.${filter.key}`]: {
                        key: filter.key,
                        selected: true,
                        category,
                    },
                };
            });
        });
        handleChangeFilters(currentFilters);
    };
    const changeFilters = (category, filter) => {
        setActiveFilters((prev) => {
            let changedCategory = [...(prev[category] || [])];
            if (changedCategory.some((f) => f.key === filter.key)) {
                changedCategory = changedCategory.filter((f) => f.key !== filter.key);
            }
            else {
                changedCategory.push(filter);
            }
            return {
                ...prev,
                [category]: changedCategory,
            };
        });
    };
    const checkFiltersStatus = useCallback((category, filterKey) => {
        return activeFilters[category]?.some((f) => f.key === filterKey) || false;
    }, [activeFilters]);
    useEffect(() => {
        if (selectedFilters) {
            const activeFilters = {};
            Object.keys(selectedFilters).forEach((kk) => {
                const [categoryKey, filterKey] = kk.split(".");
                if (categoryKey === OPEN_NOW_CATEGORY) {
                    activeFilters[categoryKey] = [OPEN_NOW_FILTER_OBJ];
                    return;
                }
                if (selectedFilters[kk]?.selected) {
                    const filter = allFilters.find((fc) => fc.key === categoryKey)?.filters.find((f) => f.key === filterKey);
                    if (activeFilters[categoryKey]) {
                        activeFilters[categoryKey].push(filter);
                    }
                    else {
                        activeFilters[categoryKey] = [filter];
                    }
                }
            });
            setActiveFilters(activeFilters);
        }
    }, [allFilters, selectedFilters]);
    const handleApplyOpenNowCheckbox = () => {
        if (!isOpenNowFilterEnabled)
            return;
        const applyFiltersParams = {};
        if (activeFilters[OPEN_NOW_CATEGORY]) {
            applyFiltersParams.categoryToSkip = OPEN_NOW_CATEGORY;
        }
        else {
            applyFiltersParams.additionalCategory = {
                [OPEN_NOW_CATEGORY]: [OPEN_NOW_FILTER_OBJ],
            };
        }
        applyFilters(applyFiltersParams);
    };
    const handleDropdownSelect = (categoryKey, x, e) => {
        if (e.option)
            changeFilters(categoryKey, e.option);
    };
    const handleDropdownRestart = (categoryKey) => {
        applyFilters({ categoryToSkip: categoryKey });
    };
    return {
        handleDropdownRestart,
        handleDropdownSelect,
        handleApplyOpenNowCheckbox,
        checkFiltersStatus,
        changeFilters,
        applyFilters,
        activeFilters,
    };
};
//# sourceMappingURL=useStoreFilters.js.map